import React, { FC } from "react";
import { Props } from "./types";
import * as S from "./styles";

const ClarityPlanCard: FC<Props> = ({
  handleGoToPayments,
  price,
  isFreeUser,
}) => {
  return (
    <S.PricingCard isHighlighted={isFreeUser}>
      <S.PricingCardHeader isHighlighted={isFreeUser}>
        {isFreeUser && (
          <S.PricingBadge>
            <S.PricingBadgeText>MOST POPULAR</S.PricingBadgeText>
          </S.PricingBadge>
        )}
        <S.PricingCardTitle isHighlighted={isFreeUser}>
          CareerFit Clarity
        </S.PricingCardTitle>
      </S.PricingCardHeader>
      <S.PricingCardBody>
        <S.PriceSection>
          <S.PriceWrapper>
            <S.PriceAmount>{price}</S.PriceAmount>
            <S.PriceCurrency>€</S.PriceCurrency>
          </S.PriceWrapper>
          <S.CheckItem>
            <S.CheckIcon>
              <svg
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM8 15L3 10L4.41 8.59L8 12.17L15.59 4.58L17 6L8 15Z"
                  fill="#f6921e"
                />
              </svg>
            </S.CheckIcon>
            <S.CheckText>One-time payment</S.CheckText>
          </S.CheckItem>
          {isFreeUser && (
            <S.CheckItem>
              <S.CheckIcon>
                <svg
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM8 15L3 10L4.41 8.59L8 12.17L15.59 4.58L17 6L8 15Z"
                    fill="#f6921e"
                  />
                </svg>
              </S.CheckIcon>
              <S.CheckText>Includes CareerFit Essentials</S.CheckText>
            </S.CheckItem>
          )}
          <S.CheckItem>
            <S.CheckIcon>
              <svg
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M10 0C4.48 0 0 4.48 0 10C0 15.52 4.48 20 10 20C15.52 20 20 15.52 20 10C20 4.48 15.52 0 10 0ZM8 15L3 10L4.41 8.59L8 12.17L15.59 4.58L17 6L8 15Z"
                  fill="#f6921e"
                />
              </svg>
            </S.CheckIcon>
            <S.CheckText>Includes 1 expert session</S.CheckText>
          </S.CheckItem>
        </S.PriceSection>
        {isFreeUser && (
          <S.PricingDescription>
            Clarity and confidence through expert guidance.
          </S.PricingDescription>
        )}
        <S.IncludedSection>
          <S.IncludedTitle>What&rsquo;s included</S.IncludedTitle>
          <S.IncludedItem>
            <S.IncludedBullet />
            <S.IncludedText>
              One 30 Minute feedback session with CareerFit Strategist to review
              results, discuss patterns and highlight key strengths
            </S.IncludedText>
          </S.IncludedItem>
          <S.IncludedItem>
            <S.IncludedBullet />
            <S.IncludedText>
              Personalised interpretation of your results to add more real world
              context to your individual report
            </S.IncludedText>
          </S.IncludedItem>
          <S.IncludedItem>
            <S.IncludedBullet />
            <S.IncludedText>
              Focus & Fit Analysis to identify areas to develop and which career
              or study paths make most sense for you
            </S.IncludedText>
          </S.IncludedItem>
          <S.IncludedItem>
            <S.IncludedBullet />
            <S.IncludedText>
              Mini Skills Gap review to identify areas you might need to develop
              to move towards your IDEAL Career
            </S.IncludedText>
          </S.IncludedItem>
        </S.IncludedSection>
      </S.PricingCardBody>
      <S.PricingCardFooter>
        <S.PricingButton
          isHighlighted={isFreeUser}
          onClick={() => handleGoToPayments("clarity")}
        >
          Book Clarity Session
        </S.PricingButton>
      </S.PricingCardFooter>
    </S.PricingCard>
  );
};

export default ClarityPlanCard;
